/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SemiStaticData = {
    properties: {
        regions: {
            type: 'RegionList',
            isRequired: true,
        },
        areasOfInterest: {
            type: 'AreaOfInterestList',
            isRequired: true,
        },
        languages: {
            type: 'LanguageList',
            isRequired: true,
        },
        leagueCategories: {
            type: 'array',
            contains: {
                type: 'LeagueCategory',
            },
            isRequired: true,
        },
        goalTypes: {
            type: 'dictionary',
            contains: {
                type: 'GoalTypeList',
            },
            isRequired: true,
        },
        cardTypes: {
            type: 'dictionary',
            contains: {
                type: 'CardTypeList',
            },
            isRequired: true,
        },
        chanceTypes: {
            type: 'dictionary',
            contains: {
                type: 'ChanceTypeList',
            },
            isRequired: true,
        },
        lineupTypes: {
            type: 'LineupTypeList',
            isRequired: true,
        },
        statisticCenter: {
            type: 'StatisticCenter',
            isRequired: true,
        },
        statisticCenterV2: {
            type: 'dictionary',
            contains: {
                type: 'StatisticCenter',
            },
        },
        playerPositions: {
            type: 'PlayerPositionList',
            isRequired: true,
        },
        fantaBoosters: {
            type: 'array',
            contains: {
                type: 'FantaBooster',
            },
            isRequired: true,
        },
        fantaConfig: {
            type: 'FantaConfig',
            isRequired: true,
        },
        fantaLineup: {
            type: 'LineupType',
            isRequired: true,
        },
        countries: {
            type: 'CountryList',
            isRequired: true,
        },
        interstitialFrequency: {
            type: 'array',
            contains: {
                type: 'number',
            },
        },
        adFreePopupFrequency: {
            type: 'array',
            contains: {
                type: 'number',
            },
        },
    },
} as const;
